function trackPageView({payload: {path}}) {
    window.ga('set', {
        page: path
    });
    window.ga('send', {
        hitType: 'pageview'
    });
}

function trackServerCall({payload: {success, elapsedTime, path, method}}) {
    window.ga('send', {
        hitType: 'event',
        eventCategory: 'serverCall',
        eventAction: `${path}:${method}`,
        eventLabel: success ? 'success' : 'failure',
        eventValue: elapsedTime
    });
}

function trackWizard({eventName}) {
    window.ga('send', {
        hitType: 'event',
        eventCategory: 'wizard',
        eventAction: eventName
    });
}

function trackPurchase({payload: {id, offering, taxes, total, productName}}) {
    window.ga('ecommerce:addTransaction', {
        id,
        revenue: total.amount,
        tax: taxes.amount,
        currency: total.currency
    });
    window.ga('ecommerce:addItem', {
        id,
        name: productName,
        category: offering,
        price: total.amount - taxes.amount,
        currency: total.currency
    });
    window.ga('ecommerce:send');
}

function trackInputInteraction(elementId) {
    window.ga('send', {
        hitType: 'event',
        eventCategory: 'tracking',
        eventLabel: 'fieldInteracted',
        eventValue: elementId
    });
}

function trackPrefill(elementId) {
    window.ga('send', {
        hitType: 'event',
        eventCategory: 'tracking',
        eventLabel: 'prefillChanged',
        eventValue: elementId
    });
}

function trackError(error) {
    window.ga('send', {
        hitType: 'event',
        eventCategory: 'tracking',
        eventLabel: 'errorGenerated',
        eventValue: error
    });
}

function trackOffering(offering) {
    window.ga('send', {
        hitType: 'event',
        eventCategory: 'tracking',
        eventLabel: 'offeringChanged',
        eventValue: offering
    });
}

function trackNavBar(step) {
    window.ga('send', {
        hitType: 'event',
        eventCategory: 'tracking',
        eventLabel: 'navbarStepSelected',
        eventValue: step
    });
}

function trackDocumentUpload(document) {
    window.ga('send', {
        hitType: 'event',
        eventCategory: 'tracking',
        eventLabel: 'documentUploaded',
        eventValue: document
    });
}

function trackPayment(payment) {
    window.ga('send', {
        hitType: 'event',
        eventCategory: 'tracking',
        eventLabel: 'paymentChanged',
        eventValue: payment
    });
}

function trackDocuSign() {
    window.ga('send', {
        hitType: 'event',
        eventCategory: 'tracking',
        eventLabel: 'policySigned',
        eventValue: ''
    });
}

export default {
    trackPageView,
    trackServerCall,
    trackWizard,
    trackPurchase,
    trackInputInteraction,
    trackPrefill,
    trackError,
    trackOffering,
    trackNavBar,
    trackDocumentUpload,
    trackPayment,
    trackDocuSign
};